const projectsData = {
  techCategories: [
    "all",
    "html",
    "css",
    "javascript",
    "react",
    "api",
    "firebase",
    "redux",
    "mongoDB",
    "node.js",
    "express",
    "graphQL",
    "typescript",
  ],
  projects: [
    {
      id: 13,
      name: "blueprint test prep",
      url: "https://bit.ly/blueprint-sophie",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Blueprint.png`,
      technologies: [
        "html",
        "scss",
        "javascript",
        "typescript",
        "react",
        "redux",
        "graphQL",
        "apollo",
      ],
    },
    {
      id: 12,
      name: "waffs shop",
      url: "https://corgowaffles.com",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Waffs-Shop.png`,
      technologies: [
        "html",
        "css",
        "scss",
        "javascript",
        "typescript",
        "react",
        "redux",
        "graphQL",
        "shopify",
        "api",
      ],
    },
    {
      id: 11,
      name: "smolify",
      url: "https://sophie-tsai.github.io/smolify",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Smolify.png`,
      technologies: [
        "html",
        "css",
        "javascript",
        "react",
        "redux",
        "mongoDB",
        "mongoose",
        "node.js",
        "express",
      ],
    },
    {
      id: 10,
      name: "homequarters",
      url: "https://sophie-tsai.github.io/HomeQuarters",
      img: `${process.env.PUBLIC_URL}/projectsImgs/HomeQuarters.png`,
      technologies: [
        "html",
        "css",
        "javascript",
        "react",
        "firebase",
        "vanta.js",
      ],
    },
    {
      id: 9,
      name: "photoshopper",
      url: "https://sophie-tsai.github.io/Photo-Shopper/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/PhotoShopper.png`,
      technologies: ["html", "css", "javascript", "react", "api"],
    },
    {
      id: 8,
      name: "what's this dog breed?",
      url: "https://sophie-tsai.github.io/Dog-Breed-Quiz/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Dog-Breed-Quiz.png`,
      technologies: ["html", "css", "javascript", "react", "api", "firebase"],
    },
    {
      id: 7,
      name: "higher or lower?",
      url: "https://sophie-tsai.github.io/Higher-Lower/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Higher-Lower.png`,
      technologies: ["html", "css", "javascript", "api"],
    },
    {
      id: 6,
      name: "calculator",
      url: "https://sophie-tsai.github.io/Calculator/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Calculator.png`,
      technologies: ["html", "css", "javascript"],
    },
    {
      id: 5,
      name: "to do list",
      url: "https://sophie-tsai.github.io/To-Do-List/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/ToDo-List.png`,
      technologies: ["html", "css", "javascript"],
    },
    {
      id: 4,
      name: "the number game",
      url: "https://sophie-tsai.github.io/Number-Game/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/The-Number-Game.png`,
      technologies: ["html", "css", "javascript"],
    },
    {
      id: 3,
      name: "pomodoro timer",
      url: "https://sophie-tsai.github.io/Timer/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Pomodoro-Timer.png`,
      technologies: ["html", "css", "javascript"],
    },
    {
      id: 2,
      name: "drum kit",
      url: "https://sophie-tsai.github.io/Drum-Kit/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Drum-Kit.png`,
      technologies: ["html", "css", "javascript"],
    },
    {
      id: 1,
      name: "motivational quote machine",
      url: "https://sophie-tsai.github.io/Random-Quote-Machine/",
      img: `${process.env.PUBLIC_URL}/projectsImgs/Motivational-Quote-Machine.png`,
      technologies: ["html", "css", "javascript"],
    },
  ],
};

export default projectsData;
